import React from "react";
import { Collapse, Button } from "antd";
import NYCLicences from "./NYCLicences/NYCLicences";
import OtherLicences from "./OtherLicences/OtherLicences";

const { Panel } = Collapse;

const BusinessLicences = (props) => {
  return (
    <>
      <Collapse defaultActiveKey={["1", "2"]}>
        <Panel header="NYC License" key="1">
          <NYCLicences />
        </Panel>
        <Panel header="Other License" key="2">
          <OtherLicences />
        </Panel>
      </Collapse>
      <div style={{ marginTop: 16 }}>
        <Button
          type="primary"
          size="large"
          onClick={() => props.onStepChange?.(props.currentStep + 1)}
        >
          Continue to next section
        </Button>
      </div>
    </>
  );
};

export default BusinessLicences;
